import { axiosPost } from "./ajaxServices";
import {
  urlGetShopOrderList,
  urlGetShopOrderDetail,
  urlUpdateShopOrderStatus,
  urlDeleteShopOrder,
  urlApproveShopOrder,
} from "./CONSTANTS";

export const apiGetShopOrderList = (
  currentPage,
  pageSize,
  startDate,
  endDate,
  orderStatus = "",
  orderType = "",
  approvalStatus = ""
) => {
  const url = urlGetShopOrderList;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("currentPage", currentPage);
  formData.append("pageSize", pageSize);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  formData.append("order_status", orderStatus);
  formData.append("order_type", orderType);
  formData.append("approval_status", approvalStatus);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export function apiApproveShopOrder(id) {
  const url = urlApproveShopOrder;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const apiGetShopOrderDetail = (id) => {
  const url = urlGetShopOrderDetail;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export function apiUpdateShopOrderStatus(id, orderStatus) {
  const url = urlUpdateShopOrderStatus;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  formData.append("order_status", orderStatus);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export function apiDeleteShopOrder(id) {
  const url = urlDeleteShopOrder;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
